export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE';

export const SET_OTP = 'SET_OTP';

export const OTP_REQUIRED = 'OTP_REQUIRED';